export enum TAB_PARAMS {
  POPULAR = 'popular',
  CATEGORIES = 'categories',
}
